﻿import { Link } from "react-router-dom";
import type { EmergencyEventItem } from "@/types.ts";
interface RiskUsersSectionProps {
    events: EmergencyEventItem[];
}
const isActiveEvent = (event: EmergencyEventItem) => {
    return ["OPEN", "ACKNOWLEDGED", "IN_PROGRESS"].includes(event.eventStatus);
};
const getEventLabel = (event: EmergencyEventItem) => {
    return event.eventTypeShortName ?? event.eventTypeName ?? event.eventType;
};
const getStatusLabel = (event: EmergencyEventItem) => {
    return event.eventStatusShortName ?? event.eventStatusName ?? event.eventStatus;
};
const getRiskLevel = (event: EmergencyEventItem): "critical" | "warning" => {
    return event.riskLevel === "HIGH" || event.eventStatus === "OPEN" ? "critical" : "warning";
};
const RiskUsersSection = ({ events }: RiskUsersSectionProps) => {
    const riskEvents = events.filter(isActiveEvent).slice(0, 4);
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-user-unfollow-line text-red-500 text-sm"/>
          <h3 className="text-sm font-semibold text-slate-800">확인 필요 어르신 현황</h3>
          <span className="text-xs font-bold text-white bg-red-500 px-1.5 py-0.5 rounded">
            {riskEvents.length}
          </span>
        </div>
        <Link to="/admin/life-signal" className="text-xs text-blue-600 hover:text-blue-700 font-medium">
          전체 보기
        </Link>
      </div>

      <div className="divide-y divide-slate-100">
        {riskEvents.length === 0 ? (<div className="px-4 py-8 text-center text-sm text-slate-500">현재 확인이 필요한 이벤트가 없습니다.</div>) : (riskEvents.map((event) => {
            const riskLevel = getRiskLevel(event);
            return (<div key={event.eventId} className="px-4 py-3 hover:bg-slate-50 transition-colors">
                <div className="flex items-start gap-3">
                  <div className={`flex items-center justify-center w-8 h-8 rounded shrink-0 ${riskLevel === "critical" ? "bg-red-500" : "bg-orange-500"}`}>
                    <i className={`text-white text-sm ${riskLevel === "critical" ? "ri-alarm-warning-line" : "ri-error-warning-line"}`}/>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-semibold text-slate-800">{event.elderlyName}</span>
                      <span className="text-xs text-slate-400">Senior 계정 ID {event.seniorUserAccountId}</span>
                      <span className={`text-xs font-semibold px-1.5 py-0.5 rounded ${riskLevel === "critical"
                    ? "bg-red-50 text-red-700 border border-red-100"
                    : "bg-orange-50 text-orange-700 border border-orange-100"}`}>
                        {riskLevel === "critical" ? "긴급" : "주의"}
                      </span>
                    </div>
                    <p className="text-xs text-slate-600 mt-0.5">{getEventLabel(event)}</p>
                    <div className="flex items-center gap-3 mt-1">
                      <span className="text-xs text-slate-400">상태: {getStatusLabel(event)}</span>
                    </div>
                  </div>

                  <Link to={`/admin/users/seniors/${event.seniorUserAccountId}?tab=care`} className="shrink-0 px-2.5 py-1 text-xs font-medium text-blue-600 border border-blue-200 rounded hover:bg-blue-50 transition-colors">
                    상세
                  </Link>
                </div>
              </div>);
        }))}
      </div>
    </div>);
};
export default RiskUsersSection;
